// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1KgtL","topBottomGutter":"Layout_topBottomGutter__2E0ky"};